var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import moment from 'moment';
import React, { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { FilterTable } from 'src/Components/Common';
import { AdminLayout } from 'src/Layouts';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import { setFormSelected, setSelectedBuilding, setSelectedEndDate, setSelectedStartDate, } from 'src/redux/slices/tableFiltersSlice';
import { getData } from 'src/Utils/api';
import { BOOKING_BLOCKED_DATES, BOOKING_BLOCKED_DATES_API, BUILDING_API, CREATE_BLOCKED_DATE, DATE_FORMAT_MOMENT, ROUTES } from 'src/Utils/constants';
import { createData } from 'src/Utils/utils';
import { createBuilding } from '../ReservationPage/utils';
import Modal from './Modal/Modal';
import { deleteBlockedDate } from './services';
import { Container, Title } from './styles';
import { handleCells, WIDTHS } from './utils';
var BookingBlockedDatesPage = function () {
    var dispatch = useAppDispatch();
    var history = useHistory();
    var _a = useState([]), rows = _a[0], setRows = _a[1];
    var _b = useState(), buildingList = _b[0], setBuildingList = _b[1];
    var _c = useAppSelector(function (state) { return state.tableFiltersSlice; }), selectedBuilding = _c.selectedBuilding, startDate = _c.startDate, endDate = _c.endDate;
    var _d = useState(false), reloadBookingBlockedDates = _d[0], setReloadBookingBlockedDates = _d[1];
    var _e = useState(''), blockedDateIdToDelete = _e[0], setBlockedDateIdToDelete = _e[1];
    var _f = useState(false), isModalOpen = _f[0], setIsModalOpen = _f[1];
    var mutateDeleteBlockedDate = useMutation(deleteBlockedDate, {
        onSuccess: function () { return setReloadBookingBlockedDates(!reloadBookingBlockedDates); },
    })[0];
    useQuery(BUILDING_API, function () { return getData('/buildings'); }, {
        refetchOnWindowFocus: false,
        onSuccess: function (data) {
            var buildings = data.buildings
                .map(function (_a) {
                var name = _a.name, id = _a.id, code = _a.code;
                return createBuilding(name, id, rows, code);
            })
                .sort(function (a, b) { return a.label.localeCompare(b.label, 'es'); });
            setBuildingList(buildings);
        },
    });
    var _g = useQuery([
        BOOKING_BLOCKED_DATES_API,
        selectedBuilding,
        startDate,
        endDate,
        reloadBookingBlockedDates,
    ], function () {
        return getData("/booking_blocked_dates", {
            building_id: selectedBuilding === null || selectedBuilding === void 0 ? void 0 : selectedBuilding.value,
            start_date: startDate
                ? moment(startDate).format(DATE_FORMAT_MOMENT)
                : null,
            end_date: endDate ? moment(endDate).format(DATE_FORMAT_MOMENT) : null,
        });
    }, {
        onSuccess: function (data) {
            var _a;
            if (!((_a = data === null || data === void 0 ? void 0 : data.booking_blocked_dates) === null || _a === void 0 ? void 0 : _a.length)) {
                setRows([]);
                return;
            }
            var sortedDates = __spreadArrays(data.booking_blocked_dates).sort(function (a, b) {
                return moment(b.created_at).diff(moment(a.created_at));
            });
            setRows(sortedDates.map(function (_a) {
                var id = _a.id, date = _a.date, recurring = _a.recurring, general_block = _a.general_block, entity_id = _a.entity_id, entity_type = _a.entity_type, amenity_name = _a.amenity_name;
                return (__assign(__assign({}, createData(moment(date).format('DD/MM/YYYY'), general_block ? 'General' : 'Específico', recurring ? 'Sí' : 'No', entity_type === 'Amenity' ? 'Amenity' : 'Edificio', amenity_name ? amenity_name : 'N/A', null)), { ID: id }));
            }));
        },
        enabled: selectedBuilding,
        refetchOnWindowFocus: false,
    }), isLoadingReservations = _g.isLoading, refetch = _g.refetch;
    var selectBuilding = function (building) {
        dispatch(setSelectedBuilding(building));
        dispatch(setFormSelected(false));
    };
    var selectStartDate = function (startDate) {
        return dispatch(setSelectedStartDate(startDate));
    };
    var selectEndDate = function (endDate) {
        return dispatch(setSelectedEndDate(endDate));
    };
    var handleDelete = function (id) {
        setBlockedDateIdToDelete(String(id));
        setIsModalOpen(true);
    };
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, BOOKING_BLOCKED_DATES),
            React.createElement(FilterTable, { headCells: handleCells(), buildingList: buildingList, building: null, rows: rows, modalButton: CREATE_BLOCKED_DATE, handleButtonClick: function () {
                    return history.push({
                        pathname: ROUTES.create_blocked_date,
                    });
                }, hasButton: true, startDate: startDate, setStartDate: selectStartDate, endDate: endDate, setEndDate: selectEndDate, isLoading: isLoadingReservations, selectedBuilding: selectedBuilding, setSelectedBuilding: selectBuilding, refetch: refetch, compareDateWithoutHours: true, width: WIDTHS, userWidth: WIDTHS, hasDots: true, isBlockedDates: true, handleEdit: function (id) {
                    history.push(ROUTES.edit_blocked_date.replace(':id', String(id)));
                }, handleDelete: handleDelete }),
            React.createElement(Modal, { isOpen: isModalOpen, setIsOpen: setIsModalOpen, handleCancel: function () { return mutateDeleteBlockedDate(blockedDateIdToDelete); }, description: '' }))));
};
export default BookingBlockedDatesPage;
